const VOCI = [
  "Pronto intervento H24/7",
  "Milano",
  "Monza",
  "Como",
  "Bergamo",
  "Brescia",
  "Pavia",
  "Lecco",
  "Varese",
  "Sondrio",
  "Cremona",
  "Lodi",
  "Mantova",
  "Preventivo gratuito",
  "Tecnici certificati",
];

function Nastro() {
  return (
    <div className="flex shrink-0 items-center">
      {VOCI.map((v) => (
        <span key={v} className="flex items-center">
          <span className="whitespace-nowrap px-6 font-display text-sm font-semibold uppercase tracking-[0.25em] text-slate-400">
            {v}
          </span>
          <span className="text-amber-500">✦</span>
        </span>
      ))}
    </div>
  );
}

export function Marquee() {
  return (
    <div
      className="relative overflow-hidden border-y border-slate-800 bg-abyss py-5"
      data-testid="marquee-editoriale"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        <Nastro />
        <Nastro />
      </div>
    </div>
  );
}
